import type { LoginRequest } from '@/features/auth/models/auth-login';
import type { ExtendedControllerProps } from '@/shared/types/base-form';
import { TextField } from '@mui/material';
import i18next from 'i18next';

export const loginFormSchema: ExtendedControllerProps<LoginRequest>[] = [
  {
    name: 'username',
    render: ({ field: { value, onChange }, fieldState: { error } }) => {
      return (
        <TextField
          className='mex:col-span-12'
          value={value}
          onChange={onChange}
          label={i18next.t('auth.login.username')}
          fullWidth
          required
          error={!!error}
          helperText={error?.message}
        />
      );
    }
  },
  {
    name: 'otp',
    render: ({ field: { value, onChange }, fieldState: { error } }) => {
      return (
        <TextField
          className='mex:col-span-12'
          value={value}
          onChange={onChange}
          label={i18next.t('auth.login.otp')}
          type='text'
          fullWidth
          required
          error={!!error}
          helperText={error?.message}
        />
      );
    }
  }
];
